import StaticCrumb from '../components/StaticCrumb';
import { BreadcrumbRouteConfig } from '../types';

export const filesRoutes: BreadcrumbRouteConfig = {
    path: 'files',
    breadcrumbs: [
        {
            component: StaticCrumb,
            props: {
                label: 'Files',
                href: '/agents/:agentId/files',
            },
        },
    ],
    children: [
        {
            path: ':bucketName',
            breadcrumbs: [
                {
                    component: StaticCrumb,
                    props: {
                        label: ':bucketName',
                        isCurrentPage: true,
                    },
                },
            ],
        },
    ],
};
